import $ from "jquery";
import "@story/story_assets/modal/modal_gallery";

$(document).ready(function() {

	// *************************************************************************
	// Mobile menu
	// *************************************************************************
	$(".page-hamburger").click(function() {
		$(".page-navigation").slideDown();
	})

	$(".page-menu .submenu > a").click(function(event) {
		var isMobile = $(".page-hamburger").is(":visible");
		if (!isMobile) { return; }

		event.preventDefault();
		$(this).parent().find("ul").slideToggle();
	});
});